module.exports = __webpack_public_path__ + "img/energized_line_monitor.e088e1bd.jpeg";